// Định nghĩa ShiftCode enum
export const ShiftCode = {
	AFTERNOON: 'C',
	MORNING: 'S',
	NONE: '',

	getName: (code) => {
		switch (code) {
			case 'C':
				return 'Chiều'
			case 'S':
				return 'Sáng'
			default:
				return ''
		}
	},

	isMorning: (code) => code === 'S',
	isAfternoon: (code) => code === 'C',
}

// Định nghĩa OrderStatus enum
export const OrderStatus = {
	CREATE: 'create',
	TRANSFER: 'transfer',
	PRODUCE: 'produce',
	SHIP: 'ship',
	PENDING_PRODUCE: 'pending-produce',
	SUCCESS: 'success',
	PENDING_DELETE_PRODUCE: 'pending-delete-produce',
	CONFIRM_DELETE_PRODUCE: 'confirm-delete-produce',
	PENDING_DELETE_SHIP: 'pending-delete-ship',
	CONFIRM_DELETE_SHIP: 'confirm-delete-ship',
	PENDING_DELETE_SUCCESS: 'pending-delete-success',
	CONFIRM_DELETE_SUCCESS: 'confirm-delete-success',
	CONFIRM_DELETE: 'confirm-delete',
	PENDING_DELETE: 'pending-delete',
	PENDING_PRODUCE_QUICK: 'pending-produce-quick',

	isPendingDelete: (status) => {
		return ['pending-delete-produce', 'pending-delete-ship', 'pending-delete-success', 'pending-delete'].includes(
			status,
		)
	},

	isConfirmDelete: (status) => {
		return ['confirm-delete-produce', 'confirm-delete-ship', 'confirm-delete-success', 'confirm-delete'].includes(
			status,
		)
	},

	getTabName: (status) => {
		switch (status) {
			case 'create':
				return 'Mới'
			case 'produce':
				return 'Đang xử lý'
			case 'ship':
				return 'Đang giao'
			case 'success':
				return 'Hoàn thành'
			default:
				return ''
		}
	},
}

